import React, { useState, useEffect } from 'react'
import { Modal, Button, t } from 'antd'
import { Resizable } from 'react-resizable';
import Draggable from 'react-draggable';


export default (props) => {

  const initState = {
    visible: false,
    disabled: true,
    width: props?.width || 200,
    height: props?.height || 200,
    bounds: { left: 0, top: 0, bottom: 0, right: 0 },
  }
  const [state, setState] = useState(initState)
  const draggleRef = React.createRef();

  const onResize = (event, { element, size, handle }) => {
    const { clientWidth, clientHeight } = window.document.documentElement;

    if (size.width + 80 >= clientWidth) return
    setState((state) => ({
      ...state,
      width: size.width, height: size.height,
      // bounds: { ...state.bounds, left: state.bounds.left - state.width }
    }));
  };

  const handleOk = e => {
    setState((state) => ({ ...state, visible: false }))
  }

  const handleCancel = e => {
    setState((state) => ({ ...state, visible: false }))
  }

  const onStart = (event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) return;
    setState((state) => ({
      ...state,
      bounds: {
        left: -targetRect.left + uiData.x,
        right: clientWidth - (targetRect.right - uiData.x),
        top: -targetRect.top + uiData.y,
        bottom: clientHeight - (targetRect.bottom - uiData.y),
      },
    }))
  };

  const { bounds, disabled, visible } = state

  return (
    <Modal
      width={state.width + 50}
      destroyOnClose
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      modalRender={modal => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          onStart={(event, uiData) => onStart(event, uiData)}
        >
          <div ref={draggleRef} >{modal}</div>
        </Draggable>
      )}
      {...props}
      title={
        <div style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => {
            if (disabled) {
              setState((state) => ({ ...state, disabled: false, }))
            }
          }}
          onMouseOut={() => { setState((state) => ({ ...state, disabled: true, })) }}
          onFocus={() => { }}
          onBlur={() => { }}
        >
          {props.title || 'Draggable Modal'}
        </div>
      }
    >
      <Resizable handle={(handleAxis, ref) => <MyHandle innerRef={ref}  {...state} />}
        height={state.height} width={state.width} onResize={onResize}>
        <div className="box" id="Resizable" style={{
          width: state.width + 'px', height: state.height + 'px',
          position: 'relative', padding: 10,
        }}>
          {props.children}
        </div>
      </Resizable>
    </Modal>
  )
}

const MyHandle = (props) => {
  return <div ref={props.innerRef} className="react-resizable-handle" style={{
    width: 5, height: 5, borderRight: "1px solid #000", borderBottom: "1px solid #000",
    position: 'absolute', top: props.height, left: props.width
  }} {...props} />;
};